import styled, { keyframes } from 'styled-components'

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const SpinnerElement = styled.div`
  border: 2px solid ${(props) => (props.color === 'blue' ? 'rgba(0, 123, 255, 0.3)' : 'rgba(255, 255, 255, 0.3)')};
  border-top: 2px solid ${(props) => (props.color === 'blue' ? '#007bff' : 'white')};
  border-radius: 50%;
  width: ${(props) => props.size || '16px'};
  height: ${(props) => props.size || '16px'};
  animation: ${spin} 0.8s linear infinite;
  display: inline-block;
  margin-right: 8px;
`

export function Spinner({ size, color = 'white' }) {
  return <SpinnerElement size={size} color={color} />
}
